import { lazy } from "react";
import Loadable from "app/components/Loadable";

const GLCode = Loadable(lazy(() => import("./GLCode")));

const GLCodeRoute = [{ path: "/GLCode", element: <GLCode /> }];
export default GLCodeRoute;
